/* Size suggestions are opt-in. Native option change handling owns variant/price updates. */
if (!window.roaRecommendedSizeBound) {
  window.roaRecommendedSizeBound = true;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-roa-recommended-option]');
    if (!button || button.disabled) return;
    var input = document.getElementById(button.getAttribute('data-roa-recommended-option'));
    if (!input || input.disabled || input.type !== 'radio') return;
    input.click();
  });
}
